/*
 * Product · Finance (sections/pdp-finance.liquid). Links marked
 * data-pdp-scroll point at an in-page anchor (#order, the buy box); like
 * Replo's "scroll to hashmark" action they scroll there smoothly (instantly
 * with reduced motion) instead of jumping. Without JS the anchor still works.
 */
(function () {
  if (window.pdpFinanceLoaded) return;
  window.pdpFinanceLoaded = true;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-pdp-scroll]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
  });
})();
